export const isSameDate = (firstDate , secondDate) => {
   return firstDate.toDateString() === secondDate.toDateString()
}